export function FontChart(fontSize) {
  var whei = $(window).width()
  return (whei / 22) * fontSize / 100
}
